module.exports = __webpack_public_path__ + "static/media/pl.52ba60ab.svg";